import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './permission';
// import { createPinia } from 'pinia'
import moment from 'moment'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as echarts from 'echarts'
import VChart from 'vue-echarts'

import Vant from 'vant'
import { Toast, Dialog } from 'vant'
import 'vant/lib/index.css'


const app = createApp(App)
app.config.globalProperties.$moment = moment
app.config.globalProperties.$toast = Toast
app.config.globalProperties.$dialog = Dialog
app.config.globalProperties.$echarts = echarts
// app.provide('$moment', moment);

app.component('VChart', VChart)
app.use(store)
app.use(router)
app.use(Vant)
app.use(ElementPlus)
app.mount('#app')